<template>
  <div>
    <PageMain
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      @reload="$refs.header.query()"
      ref="tableMain"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header ref="header" slot="header" @query="getData" />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header'
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [EditLoading, BaseTable],
  components: { PageMain, PageHeader },
  props: {
    custCode: { type: String, default: () => '' },
  },
  data() {
    return { usePage: true, loading: false, tableData: [] }
  },
  methods: {
    async getData(form = {}) {
      if (!this.custCode) {
        this.tableData = []
        return
      }
      this.loading = true
      this.$api
        .noticeOrderSelectListByNewApi({
          custCode: this.custCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
